import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SelectComponent } from '../../../components/select/select.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { CamelCasePipe } from '../../../pipes/camel-case.pipe';
import { CpfPipe } from '../../../pipes/cpf.pipe';

@Component({
    selector: 'app-lista-usuarios',
    templateUrl: './lista-usuarios.component.html',
    styleUrls: ['./lista-usuarios.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SelectComponent, NgxPaginationModule, CamelCasePipe, CpfPipe]
})
export class ListaUsuariosComponent {

  @Input() dadosListaUsuarios: any;
  public usuariosPorPagina: number = 5;
  public paginaUsuarios: number = 1;

  constructor() { }

  onUsuariosPorPaginaChange (newValue : number) {
    this.usuariosPorPagina = newValue;
    this.paginaUsuarios = 1;
  }
}
